import React from 'react';
import { Link } from 'react-router-dom';
import posts from '../content/blogPosts';
import { formatDate } from '../utils';
import './Blog.css';

const BlogIndex = () => {
  return (
    <div className="blog-page">
      <main className="site-container--wide blog-main">
        <h1 className="blog-heading">Blog</h1>

        {posts.length > 0 ? (
          <div className="blog-list">
            {posts.map((post) => (
              <Link key={post.slug} to={`/blog/${post.slug}`} className="blog-post-row">
                <div className="blog-post-body">
                  <h2 className="blog-post-title">{post.title}</h2>
                  <p className="blog-post-summary">{post.summary}</p>
                </div>
                <time className="blog-post-date" dateTime={post.publishedAt}>
                  {formatDate(post.publishedAt)}
                </time>
              </Link>
            ))}
          </div>
        ) : (
          <p>Coming soon</p>
        )}
      </main>
    </div>
  );
};

export default BlogIndex;
